<template>
  <v-app>
    <CoreDrawer />
    <v-content>
      <v-container
        fluid
        class="pa-0"
      >
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  components: {
    CoreDrawer: () => import('@/components/core/Drawer')
  },

  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },

  mounted () {
    // https://stackoverflow.com/a/50683190/1415058
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()
  }
}
</script>
<style lang="scss">
  :root {
    --app-height: 100vh;
  }

  html,
  body {
      padding: 0;
      margin: 0;
      overflow: hidden !important;
      width: 100vw;
      height: 100vh;
      @media not all and (hover:hover) {
          height: var(--app-height);
      }
  }
</style>
